import { render } from "./FpuiTable.vue?vue&type=template&id=76a3df3f"
import script from "./FpuiTable.vue?vue&type=script&lang=js"
export * from "./FpuiTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__